// import { DepartmentsList } from "components/Departments";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { DepartmentsList } from "../../components/DepartmentsList";


export interface IDepartmentsListPage {}

export const DepartmentsListPage: FC<IDepartmentsListPage> = (
  props: IDepartmentsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Departments List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Departments", navigateTo: "/company/departments/list" },
      ]}
      mainContents={<DepartmentsList />}
    />
  );
};
